import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import Port from "../../../domains/Ports/Port";

interface PortsState {
  ports: Port[];
  arePortsLoading: boolean
  hasErrorLoadingPorts: boolean
}

export const SLICE_NAME = "ports";

const initialState: PortsState = {
  ports: [],
  arePortsLoading: false,
  hasErrorLoadingPorts: false,
};

export const portsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    getPorts: state => {
      state.arePortsLoading = true;
    },
    getPortsSuccess: (state, action: PayloadAction<Port[]>) => {
      state.ports = [...action.payload];
      state.arePortsLoading  = false;
    },
    getPortsError: state => {
      state.arePortsLoading = true;
      state.arePortsLoading = false;
    },
  },
});

export const { getPorts, getPortsSuccess, getPortsError } =
  portsSlice.actions;

export default portsSlice.reducer;
